import assign = require('object-assign');
import {
    FETCH_SOFTWARE_REQUEST,
    FETCH_SOFTWARE_SUCCESS,
    FETCH_SOFTWARE_FAILURE,
    FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST,
    FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS,
    FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE,
} from '../../constants/PM';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch (action.type) {
        case FETCH_SOFTWARE_REQUEST:
        case FETCH_SOFTWARE_SUCCESS:
        case FETCH_SOFTWARE_FAILURE:
        case FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST:
        case FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS:
        case FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE:
            return true;
        default:
            return false;
    }
}

function formatDate(job, key) {
    if (job[key]) {
        job[key] = new Date(job[key]);
    }
    return job;
}

function formatSoftware(job) {
    formatDate(job, 'date');

    return job;
}

function formatSoftwares(jobs) {
    if (Array.isArray(jobs)) {
        jobs.forEach(formatSoftware);
        return jobs;
    }

    Object.keys(jobs).forEach(key => {
        jobs[key].forEach(formatSoftware);
    });

    return jobs;
}

export default function systems(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST:
        case FETCH_SOFTWARE_REQUEST: {
            return assign({}, state, {
                software: {
                    loading: true
                }
            });
        }
        case FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS: {
            return assign({}, state, {
                software: {
                    loading: false,
                    data: formatSoftwares(action.payload.software)
                }
            });
        }
        case FETCH_SOFTWARE_SUCCESS: {
            return assign({}, state, {
                software: {
                    loading: false,
                    data: formatSoftwares(action.payload)
                }
            });
        }
        case FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE:
        case FETCH_SOFTWARE_FAILURE: {
            return assign({}, state, {
                software: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/software.ts